import React from 'react'

import { Logo } from '@droidmap/frontend-ui'

interface AuthPageProps {
  title: string
  children: React.ReactNode
  className?: string
}

export default function AuthPage(props: AuthPageProps) {
  return (
    <div className="relative flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="relative z-[1] sm:mx-auto sm:w-full sm:max-w-sm">
        <Logo className="mx-auto h-10 w-auto" />
        <h2
          className={`text-text text-center text-2xl font-bold leading-9 tracking-tight ${
            props.className ?? 'mt-6'
          }`}
        >
          {props.title}
        </h2>
      </div>
      <div className="relative z-[1]">{props.children}</div>
    </div>
  )
}
